import useSizeCheck from "../hooks/useSizeCheck";
import React, {lazy, Suspense, useEffect, useState} from "react";
import ConfirmInfo from "./confirm/ConfirmInfo";
import {LocStore} from "../utils";
import axios from "axios";
import {Route, Routes, useLocation} from "react-router-dom";
import {isMobile} from "react-device-detect";
import {observer} from "mobx-react";
import shopStore from "../store/shopStore";
import async from "async";
import roomStore from "../store/roomStore";
import LottiePlayer from "../components/Lottie/LottiePlayer";


const MyReservations = lazy(() => import("./my/MyReservations"));
const ReservationEntry = lazy(() => import("./my/ReservationEntry"));

const RoomInfo = lazy(() => import('./room/RoomInfo'))
const UserInfo = lazy(() => import('./user/UserInfo'))


const App = observer(() => {

    console.log('')
    useSizeCheck();
    const location = useLocation();
    // console.log('env', process.env.PUBLIC_URL)
    // console.log('env', process.env.NODE_ENV)

    const [page, setPage] = useState('room');
    const [reValid, setReValid] = useState(false)
    const [read, setRead] = useState(false);
    const [read2, setRead2] = useState(false);

    const [sms, setSms] = useState(false);
    const [lottie, setLottie] = useState(true)


    if (process.env.NODE_ENV === "production") {
        let urls = window.__reqs ?? ""

        // console.log(process.env.NODE_ENV)
        // console.log(urls, window.__reqs)
        const a = new URL(urls)

        // console.log('new url', a)
        // console.log('urls', urls)
        const b = new URLSearchParams(a?.search)
        const c = b.get('sp_no')

        // console.log(urls, 'url 파싱 전')
        // console.log(c)
        const d = window.location.pathname.replace(/\//, '');
        shopStore.spno = c;
        // console.log(d)
        LocStore('spno', c)
        LocStore(`path_${c}`, d)


    } else {
        LocStore('spno', 664)
        LocStore(`path_664`, window.location.pathname.replace(/\//, ''))
        shopStore.spno = 664;
    }

    const getAllInfoOnce = async () => {
        return new Promise((resolve, reject) => {
            try {

                async.waterfall([
                    (callback) => {
                        const _token = LocStore(`shopToken_${shopStore.spno}`)

                        axios({
                            method: 'POST',
                            url: `/shop/auth/${LocStore('spno')}`
                        }).then((res) => {
                            // console.log({res})
                            const {token} = res?.data?.data
                            const result = res?.data?.resultCode;
                            if (result === 200) {
                                LocStore(`shopToken_${shopStore.spno}`, token)
                                callback(null, token)
                            }
                        }).catch(err => {
                            callback(err, null)
                        })
                    },
                    (result, callback) => {
                        axios({
                            method: 'GET',
                            url: '/shop',
                            headers: {
                                Authorization: `Bearer ${result}`
                            }
                        }).then((res) => {
                            // console.log('/shop 데이터', res)
                            if (res?.data?.resultCode === 200) {
                                const {data} = res?.data || {};

                                console.log(data, 'shop')
                                localStorage.setItem('relay', data?.['sp_relayYN'])

                                if (isMobile) {
                                    LocStore('shopMobileInfo', {
                                        spAddress: data?.['spAddr'],
                                        spName: data?.['spName'],
                                        spTitle: data?.['spTitle']
                                    })
                                }

                                // console.log('shop 정보', {data})
                                roomStore.setShopData(data)
                                callback(null, result)
                            }
                        }).catch((err) => {
                            callback(err, null)
                        })
                    },
                    (result, callback) => {
                        axios({
                            method: 'GET',
                            url: '/rooms',
                            headers: {
                                Authorization: `Bearer ${result}`
                            }
                        }).then((res) => {
                            console.log({res})
                            if (res?.data?.resultCode === 200) {
                                roomStore.setRoomData(res?.data?.data)
                                setLottie(false)
                                callback(null, result)
                            }
                        }).catch((err) => {
                            // console.log('스터디룸 링크 에러', err)
                            if (err?.response?.data?.resultCode === 400) {
                                roomStore.setRoomData([])
                                setLottie(false)
                                reject(err)
                            }
                            // callback(err, null)
                        })
                    }

                ], (err, result) => {
                    if (err) reject(err)
                    resolve(result)
                })

            } catch (e) {
                throw Error(e)
            }
        })

    }


    useEffect(() => {
        getAllInfoOnce()
    }, [])


    if(lottie) return <LottiePlayer />

    return (
        <>
            <div className='layout'>
                {location.pathname !== "/my" && <UserInfo page={page}
                          setPage={setPage}
                          reValid={reValid}
                          setReValid={setReValid}
                          read={read}
                          setRead={setRead}
                          read2={read2}
                          setRead2={setRead2}
                          setSms={setSms}
                          sms={sms}
                />}
                <Suspense fallback={<LottiePlayer />}>
                    <Routes>
                        <Route path="/my" element={<MyReservations/>}/>
                        <Route
                            path={'/'}
                            element={<ReservationEntry><RoomInfo page={page} setPage={setPage}/></ReservationEntry>}/>
                        <Route
                            path={'/result'}
                            element={<ConfirmInfo setPage={setPage}
                                                  reValid={reValid}
                                                  setReValid={setReValid}
                                                  read={read}
                                                  setRead={setRead}
                                                  read2={read2}
                                                  setRead2={setRead2}
                                                  setSms={setSms}
                            />
                            }
                        />
                    </Routes>
                </Suspense>
            </div>

        </>
    );
});

export default App;
